module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/zh-hant_okinawa-ce0c2a23d6804db7614a3a4993c1b302.jpg";